import React, { useState, useEffect } from "react";
import api from "../../Services/api";
import { useParams, useNavigate } from "react-router-dom";
import { usePentagovContext } from "../../context/pentagovContext";
import { useAuthContext } from "../../context/authContext";
import { useOperador } from "../../Hooks/useOperador";
import MenuLateral from "../../Componentes/MenuLateral";
import MenuSuperior from "../../Componentes/MenuSuperior";
import { FaSearch, FaFolder, FaArchive, FaShieldAlt, FaChartLine } from 'react-icons/fa';

import './ServiceList.css';
import "./styles.css";

const Servicos = () => {
  const navigate = useNavigate();
  const { IDCliente } = useParams();
  const [clienteLogado, setclienteLogado] = useState();
  const [servicelist, setServiceList] = useState([]);

  const { objClienteAberto, setIDProcessoAberto, setBucketAberto } = usePentagovContext();
  const { IDOperador, nome, operador } = useOperador();
  const { authReady } = useAuthContext();

  useEffect(() => {
    if (operador && authReady) {
      inicializaTela();
    } else {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (objClienteAberto?.nome && objClienteAberto?.cnpj) {
      setclienteLogado(`${objClienteAberto.nome} - CNPJ: ${objClienteAberto.cnpj}`);
    }
  }, [objClienteAberto]);

  async function inicializaTela() {
    // Busca serviços
    let retorno = await buscaProcessos(IDOperador);
    let listaServicos = [];

    if (retorno && retorno.data && Array.isArray(retorno.data)) {
      listaServicos = [...retorno.data];
    } else {
      console.warn("Clientes não encontrados ou estrutura inesperada:", retorno.data);
      setBucketAberto(null);
    }

    // Ordena alfabeticamente pelo campo descricao
    listaServicos.sort((a, b) => {
      if (!a.descricao) return 1;
      if (!b.descricao) return -1;
      return a.descricao.localeCompare(b.descricao);
    });

    setServiceList(listaServicos);
  }

  async function buscaProcessos(IDoperador) {
    try {
      const response = await api.get(`/processo/operadorcliente/${IDoperador}/${IDCliente}`);
      //console.log('Resoponse processos:', response);
      return response;

    } catch (error) {
      console.log(error);
      return error;
    }
  }

  const handleCardClick = (IDProcesso, descricao, nomeBucketAws) => {
    console.log(descricao);
    
    setIDProcessoAberto(IDProcesso);
    setBucketAberto(nomeBucketAws);
    if (descricao === 'Planejamento Estratégico') {
      navigate(`/Planejamento/${IDCliente}/${IDProcesso}`);
    } else if (descricao === 'Auditoria') {
      navigate(`/AuditoriaSecao/${IDCliente}`); 
    } else if (descricao === 'Audit. Patrimonial') {
      navigate(`/AuditoriaPatrimonial/${IDCliente}`); 
    } else {
      navigate(`/Pastas/${IDCliente}/${IDProcesso}/${0}`);
    }
  };

  const ServiceCard = ({ service, onClick }) => {
    let Icon = FaFolder;

    switch (service.descricao) {
      case 'Guarda Documental':
        Icon = FaArchive;
        break;
      case 'Auditoria':
        Icon = FaShieldAlt;
        break;
      case 'Audit. Patrimonial':
        Icon = FaShieldAlt; 
        break;
      case 'Planejamento Estratégico':
        Icon = FaChartLine;
        break;
      default:
        Icon = FaFolder;
    }

    return (
      <div className="service-card" onClick={onClick}>
        <div className="icon"><Icon /></div>
        <h5>{service.descricao}</h5>
      </div>
    );
  };

  if (!objClienteAberto) {
    // Ou você pode retornar um spinner aqui
    return <div>Carregando processos...</div>;
  }

  return (
    <div className="menu-container-menu">
      <MenuLateral />
      <div id="painel_principal_menu" align="center">
        <MenuSuperior userId={String(IDOperador).padStart(6, '0')} userName={nome} cliente={clienteLogado} />

        <div className="service-list">
          {servicelist.map((service, index) => (
            <div className="service-item" key={index}>
              <ServiceCard
                service={service}
                onClick={() => handleCardClick(service.IDProcesso, service.descricao, service.nomeBucketAws)}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Servicos;
